import React, { useState } from 'react';
import cx from 'classnames';
import { InputFilterStyled } from './styled';
import moment from 'moment';
import { Icons, Inputs, Buttons } from 'components';

const InputFilter = ({
  theme_standard_input_filter,
  dataFilter,
  onQueryFilter,
  btnLabel,
  onExport,
  onClear,
  clearLabel,
}) => {
  const customClass = cx({
    theme_standard_input_filter: theme_standard_input_filter,
  });

  // ตั้งค่าเริ่มต้นจาก filter.defaultValue เพื่อให้ค่าที่เคยค้นหาไว้ยังอยู่ตอนกลับเข้าหน้านี้
  const [_filter, _setFilter] = useState(() => {
    let initialFilter = {};
    dataFilter &&
      dataFilter.forEach((e) => {
        if (!e.filter) return;
        // dateRank เก็บค่าเป็น query string ของช่วงวัน ต้องประกอบกลับเองตอนคืนค่าเดิม
        if (
          e.filter.type === 'dateRank' &&
          e.filter.defaultStartValue &&
          e.filter.defaultEndValue
        ) {
          initialFilter[e.accessor] = {
            fieldQuery: e.filter.fieldQuery,
            name: e.accessor,
            type: e.filter.type,
            value: `${e.filter.startFieldQuery || 'start_date'}=${
              e.filter.defaultStartValue
            }&${e.filter.endFieldQuery || 'end_date'}=${
              e.filter.defaultEndValue
            }`,
          };
        } else if (e.filter.defaultValue) {
          initialFilter[e.accessor] = {
            fieldQuery: e.filter.fieldQuery,
            name: e.accessor,
            type: e.filter.type,
            value: e.filter.defaultValue,
          };
        }
      });
    return initialFilter;
  });

  // useEffect(() => {
  //   if (Object.keys(_filter).length === 0) {
  //   } else {
  //     let queryArr = [];
  //     let query = '';
  //     Object.keys(_filter).forEach((key) => {
  //       if (_filter[key].value) {
  //         queryArr.push(`${_filter[key].fieldQuery}=${_filter[key].value}`);
  //       }
  //     });
  //     if (queryArr.length > 0) {
  //       query = `?${queryArr.join('&')}`;
  //     }
  //     onQueryFilter && onQueryFilter(query);
  //   }
  // }, [_filter]); // eslint-disable-line react-hooks/exhaustive-deps

  const clickFilter = () => {
    if (Object.keys(_filter).length === 0) {
    } else {
      let queryArr = [];
      let query = '';
      Object.keys(_filter).forEach((key) => {
        if (_filter[key].value && _filter[key].type !== 'dateRank') {
          // encode ค่าที่ผู้ใช้พิมพ์ ไม่งั้นค่าที่มี & + = # จะทำให้ query เพี้ยน
          // (dateRank ไม่ encode เพราะค่าเป็น query string สำเร็จรูปอยู่แล้ว)
          queryArr.push(
            `${_filter[key].fieldQuery}=${encodeURIComponent(
              _filter[key].value
            )}`
          );
        } else {
          queryArr.push(`${_filter[key].value}`);
        }
      });
      if (queryArr.length > 0) {
        query = `?${queryArr.join('&')}`;
      }
      onQueryFilter && onQueryFilter(query);
    }
  };

  const renderFilter = (e) => {
    switch (e.filter.type) {
      case 'text':
        return (
          <Inputs.TextField
            label={e.filter.label}
            placeholder={e.filter.placeholder && e.filter.placeholder}
            defaultValue={e.filter.defaultValue}
            onChange={(f) => {
              _setFilter({
                ..._filter,
                [e.accessor]: {
                  fieldQuery: e.filter.fieldQuery,
                  name: e.accessor,
                  type: e.filter.type,
                  value: f.target.value,
                },
              });
            }}
          />
        );

      // case 'date':
      //   return (
      //     <Inputs.InputDatePikerCustom
      //       label={e.filter.label}
      //       theme_standard_date_picker_custom
      //       placeholder={e.filter.placeholder && e.filter.placeholder}
      //       onChange={(f) => {
      //         _setFilter({
      //           ..._filter,
      //           [e.accessor]: {
      //             fieldQuery: e.filter.fieldQuery,
      //             name: e.accessor,
      //             type: e.filter.type,
      //             value: momentTZ(f).format('YYYY-MM-DD'),
      //           },
      //         });
      //       }}
      //     />
      //   );

      case 'dropdown':
        return (
          <Inputs.Dropdown
            label={e.filter.label}
            iconSvgClose={<Icons.ArrowDropdown />}
            iconSvgOpen={<Icons.ArrowDropdown up />}
            placeholder={e.filter.placeholder}
            options={e.filter.options}
            value={e.filter.defaultValue}
            onChange={(f) => {
              _setFilter({
                ..._filter,
                [e.accessor]: {
                  fieldQuery: e.filter.fieldQuery,
                  name: e.accessor,
                  type: e.filter.type,
                  value: f,
                },
              });
            }}
          />
        );

      // case 'label':
      //   return <div className={`box_label active`}>{e.labelName}</div>;

      case 'dateRank':
        return (
          <Inputs.InputDatePickerBetween
            label={e.filter.label}
            startDatePlaceholder="เริ่ม"
            endDatePlaceholder={'สิ้นสุด'}
            defaultStartDate={
              e.filter.defaultStartValue
                ? moment(e.filter.defaultStartValue, 'YYYY-MM-DD').toDate()
                : undefined
            }
            defaultEndDate={
              e.filter.defaultEndValue
                ? moment(e.filter.defaultEndValue, 'YYYY-MM-DD').toDate()
                : undefined
            }
            onChange={(f) => {
              _setFilter({
                ..._filter,
                [e.accessor]: {
                  fieldQuery: e.filter.fieldQuery,
                  name: e.accessor,
                  type: e.filter.type,
                  // ตั้งชื่อ query param เองได้ เผื่อหน้าไหนมี date range มากกว่า 1 ชุด
                  // ถ้าไม่ระบุจะเป็น start_date/end_date เหมือนเดิม
                  // ส่งเมื่อเลือกครบทั้งสองวันเท่านั้น ไม่งั้นจะได้ end_date=Invalid date
                  value:
                    f.startDate && f.endDate
                      ? `${e.filter.startFieldQuery || 'start_date'}=${moment(
                          f.startDate
                        ).format('YYYY-MM-DD')}&${
                          e.filter.endFieldQuery || 'end_date'
                        }=${moment(f.endDate).format('YYYY-MM-DD')}`
                      : '',
                },
              });
            }}
          />
        );
      case 'multiSelect':
        return (
          <Inputs.InputMultiSelect
            label={e.filter.label}
            options={e.filter.options}
            placeholder={e.filter.placeholder && e.filter.placeholder}
            defaultValue={e.filter.defaultValue}
            onChange={(f) => {
              let joinString = '';
              f.forEach((g, i) => {
                joinString += g.value;
                if (f.length - 1 !== i) {
                  joinString += ',';
                }
              });
              _setFilter({
                ..._filter,
                [e.accessor]: {
                  fieldQuery: e.filter.fieldQuery,
                  name: e.accessor,
                  type: e.filter.type,
                  value: joinString,
                },
              });
            }}
          />
        );
      default:
        break;
    }
  };

  return (
    <InputFilterStyled>
      <div className={customClass}>
        {dataFilter &&
          dataFilter.map((e, i) => (
            <div key={i}>
              <div key={i + 1} className="box_filter">
                {e.label && <div className="label_top">{e.label}</div>}
                <div key={i} style={{ width: `${e.length}` }}>
                  {renderFilter(e)}
                </div>
              </div>
            </div>
          ))}
        <div className="btn_action_filter">
          <Buttons.BgStandard
            label={btnLabel}
            height="100%"
            onClick={clickFilter}
          />
        </div>
        {onClear && (
          <div className="btn_action_filter">
            <Buttons.BgStandard
              theme_gray
              label={clearLabel || 'ล้างค่า'}
              height="100%"
              onClick={() => {
                _setFilter({});
                onClear();
              }}
            />
          </div>
        )}
        {onExport && (
          <div className="btn_action_filter">
            <Buttons.BgStandard
              theme_export_btn
              label={'Export'}
              height="100%"
              onClick={onExport}
            />
          </div>
        )}
      </div>
    </InputFilterStyled>
  );
};

InputFilter.propTypes = {};

export default InputFilter;
